import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import ScrollToTop from "./components/ScrollToTop";
import HomePage from "./pages/HomePage";
import ForSalePage from "./pages/ForSalePage";
import SoldPage from "./pages/SoldPage";
import ContactPage from "./pages/ContactPage";
import PropertyDetailPage from "./pages/PropertyDetailPage";
import AdminPage from "./pages/AdminPage";
import AboutPage from "./pages/AboutPage";
import LoginPage from "./pages/LoginPage";
import SellPage from "./pages/SellPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/a-vendre" element={<ForSalePage />} />
          <Route path="/vendus" element={<SoldPage />} />
          <Route path="/a-propos" element={<AboutPage />} />
          <Route path="/vendre-votre-bien" element={<SellPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/bien/:id" element={<PropertyDetailPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/admin" element={<AdminPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" />
    </div>
  );
}

export default App;
